import { Map } from "immutable"

import { UNAUTHENTICATED } from "../../actions/action-types"
import {
    serialiseSearchCriteria,
    idify,
    combineData
} from "./paging-reducer-utils"

const _actionsToHandle = {
    LIST_REQUEST: "",
    LIST_RESPONSE: "",
    LIST_CACHED_RESPONSE: "",
    LIST_ERROR_RESPONSE: "",
    ITEM_SAVE_RESPONSE: "",
    ITEM_DELETE_RESPONSE: ""
}

export default (
    actionsToHandle = {},
    defaultSearchCriteria = Map(),
    providedDefaultState,
    shouldCombineData = true
) => {
    const defaultState = providedDefaultState || {
        [serialiseSearchCriteria(defaultSearchCriteria)]: {
            searchCriteria: defaultSearchCriteria
        }
    }
    actionsToHandle = {
        ..._actionsToHandle,
        ...actionsToHandle
    }
    const {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE,
        ITEM_SAVE_RESPONSE,
        ITEM_DELETE_RESPONSE
    } = actionsToHandle
    return (state = defaultState, action) => {
        const {
            type,
            limit,
            offset,
            nextOffset,
            searchCriteria,
            id,
            isInvalidating
        } = action
        const serialisedSearchCriteria = serialiseSearchCriteria(searchCriteria)
        const previousItemState = state[serialisedSearchCriteria]
        switch (type) {
            case LIST_REQUEST:
                return {
                    ...state,
                    [serialisedSearchCriteria]: {
                        ...previousItemState,
                        isFetching: true,
                        isInvalidating: isInvalidating || false,
                        limit,
                        offset,
                        nextOffset,
                        searchCriteria
                    }
                }
            case LIST_CACHED_RESPONSE:
                return {
                    ...state,
                    [serialisedSearchCriteria]: {
                        ...previousItemState,
                        isFetching: false,
                        isInvalidating: false,
                        limit,
                        offset,
                        nextOffset,
                        searchCriteria
                    }
                }
            case LIST_RESPONSE:
                const {
                    data: previousData,
                    lastUpdatedAt: previousUpdatedAt
                } = previousItemState
                const { data, receivedAt } = action
                const idData = idify(data)
                return {
                    ...state,
                    [serialisedSearchCriteria]: {
                        ...previousItemState,
                        isFetching: false,
                        isInvalidating: false,
                        limit,
                        offset,
                        searchCriteria,
                        nextOffset,
                        lastUpdatedAt: receivedAt || previousUpdatedAt,
                        isPossibleNextPage: idData.length >= limit,
                        data: shouldCombineData
                            ? combineData(
                                  previousData,
                                  idData,
                                  offset,
                                  isInvalidating
                              )
                            : idData
                    }
                }
            case LIST_ERROR_RESPONSE:
                return {
                    ...state,
                    [serialisedSearchCriteria]: {
                        ...previousItemState,
                        isFetching: false,
                        isInvalidating: false
                    }
                }
            case ITEM_SAVE_RESPONSE:
                return Object.keys(state)
                    .map(key => ({
                        [key]: {
                            ...state[key],
                            isInvalidating: true,
                            nextOffset: 0
                        }
                    }))
                    .reduce((newState, pageRequest) => {
                        return {
                            ...newState,
                            ...pageRequest
                        }
                    }, state)
            case ITEM_DELETE_RESPONSE:
                return Object.keys(state)
                    .filter(key => state[key].data)
                    .map(key => {
                        return {
                            [key]: {
                                ...state[key],
                                data: state[key].data.filter(
                                    storedId => storedId !== id
                                )
                            }
                        }
                    })
                    .reduce((newState, pageRequest) => {
                        return {
                            ...newState,
                            ...pageRequest
                        }
                    }, state)

            case UNAUTHENTICATED:
                return defaultState
            default:
                return state
        }
    }
}
